import React from "react";

const CoursePromo = ({
  title,
  videoUrl,
  className = "tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative",
}) => {
  return (
    <section className={className}>
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>

      <div className="tw-w-full tw-min-h-[400px] tw-flex tw-justify-center tw-items-center tw-bg-gray-200 tw-rounded-lg tw-overflow-hidden">
        {videoUrl ? (
          <iframe
            title={"course promo"}
            src={`${videoUrl}`}
            width="100%"
            height="480"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        ) : (
          <p className="tw-text-gray-500">No promo video available</p>
        )}
      </div>
    </section>
  );
};

export default CoursePromo;
